import React, { Suspense, useState } from 'react'
import { useParams } from 'react-router-dom'
import Header from 'src/components/Header/Header'
import Loading from 'src/components/Loading/Loading'
import UserForm from './UserForm'
import { useUser } from 'src/hooks/api'
import UserAssets from './UserAssets/UserAssets'
import Tabs from 'src/components/Tabs/Tabs'
import { FormattedMessage } from 'react-intl'
import ActivityUser from './ActivityUser'
import { LoginResponse, UserIsChild } from 'src/types'

import './User.sass'
import { useSelector } from 'react-redux'

const User = ({ initialUser, isNew }: { initialUser: UserIsChild, isNew: boolean }) => {

  const [changed, setChanged] = useState(!initialUser)
  const [user, setUser] = useState(initialUser)
  const [userActives, setUserActives] = useState<string[]>([])

  const handleUser = (user: UserIsChild) => {
    setUser(user)
    if (!changed) setChanged(true)
  }
  const handleActives = (ids: string[], isInitial?: boolean) => {
    setUserActives(ids)
    if (!isInitial && !changed) setChanged(true)
  }
  const handleSaved = () => setChanged(false)

  const mixedUser = { ...user, actives: userActives }

  return (
    <div id="user" className="page">
      <Header back />
      <section id="page-content">
        <div className="container">
          <div className="only-desktop">
            <h1><FormattedMessage id="user.title" /></h1>
            <div className="wrapper">
              <Suspense fallback={<Loading />}>
                <UserForm
                  user={mixedUser}
                  setUser={handleUser}
                  hasChanges={changed}
                  onSave={handleSaved}
                  isNew={isNew}
                />
              </Suspense>
              <Tabs
                headers={[
                  <FormattedMessage id="user-assets" />,
                  <FormattedMessage id="activity" />
                ]}
                tabs={[
                  <Suspense fallback={<Loading />}>
                    <UserAssets
                      value={userActives}
                      onChange={handleActives}
                      user={user}
                      handleUser={handleUser}
                    />
                  </Suspense>,
                  <Suspense fallback={<Loading />}>
                    <ActivityUser />
                  </Suspense>
                ]}
              />
            </div>
          </div>
          <div className="only-mobile">
            <Tabs
              headers={[
                <FormattedMessage id="user.title" />,
                <FormattedMessage id="user-assets" />,
                <FormattedMessage id="activity" />
              ]}
              tabs={[
                <Suspense fallback={<Loading />}>
                  <UserForm
                    user={mixedUser}
                    setUser={handleUser}
                    hasChanges={changed}
                    onSave={handleSaved}
                    isNew={isNew}
                  />
                </Suspense>,
                <Suspense fallback={<Loading />}>
                  <UserAssets
                    value={userActives}
                    onChange={handleActives}
                    user={user}
                    handleUser={handleUser}
                  />
                </Suspense>,
                <Suspense fallback={<Loading />}>
                  <ActivityUser />
                </Suspense>
              ]}
            />
          </div>
        </div>
      </section>
    </div>
  )
}

const UserWrapper = () =>
  <Suspense fallback={<Loading />}>
    <UserWrapperParam />
  </Suspense>

const UserWrapperParam = () => {
  const { role } = useSelector((s: {user: LoginResponse}) => s.user)

  const emptyUser: UserIsChild = {
    userId: null,
    actives: null,
    contractor: '',
    geoLock: false,
    provinces: [],
    status: '0',
    terminalChange: '0',
    turnUp: 'NO',
    code: '',
    mail: '',
    name: '',
    phone: '',
    heritage: role === 'SEMIADMIN',
    child: false
  }

  const { id } = useParams()
  const initialUser = useUser(id)

  return <User key={id} initialUser={initialUser || emptyUser} isNew={!initialUser} />
}

export default UserWrapper
